import React from "react";
import { useParams } from "react-router-dom";
import { PageHeader } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import { MyBreadcrumb } from "utils";
import RecurringForm from "./form";

export default function RecurringUpdate() {
  const { id } = useParams();
  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Billing", path: "" },
          { label: "Recurring", path: "/billing/recurring" },
          { label: "Edit", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <SyncOutlined /> }}
        title="Edit Recurring Template"
        style={{ marginBottom: 16 }}
      />
      <RecurringForm id={id} />
    </div>
  );
}
